const moment = require('moment')

module.exports.capitalize = s => s[0].toUpperCase() + s.slice(1)

module.exports.formatDatetime = date => moment(date).format('YYYY-MM-DD HH:mm:ss')
module.exports.formatDate = date => moment(date).format('YYYY-MM-DD')
module.exports.formatTime = date => moment(date).format('HH:mm:ss')
module.exports.extractDate = datetimeStr => {
    let [date] = datetimeStr.split(' ')
    return date
}
module.exports.extractTime = (datetimeStr, shortFormat) => {
    let time = datetimeStr.split(' ')[1]
    if (shortFormat) time = time.slice(0, 5)
    return time
}
module.exports.minutesToMoment = (min, baseDate = undefined) => {
    let init = moment(baseDate).startOf('day')
    return init.minutes(min)
}

const convertToTimezone = (date, timezoneOffset) => {
    date = new Date(date)
    let currentTzOffset = date.getTimezoneOffset() * -1
    if (timezoneOffset === currentTzOffset) {
        // console.log('Offsets are equal!!!')
        return date
    }
    date.setMinutes(date.getMinutes() + timezoneOffset - currentTzOffset)
    // console.log('time after applied timezone difference', timeNow, siteTzOffset)
    return date
}
module.exports.convertToTimezone = convertToTimezone
module.exports.getTimeNowForSite = site => {
    let timeNow = new Date()
    return convertToTimezone(timeNow, site.timezoneOffset)
}


const dateFormat = 'YYYY-MM-DD'
module.exports.isDateVaild = date => date && moment(date, dateFormat).isValid()

const isDatetimePassed = (datetime, timeNow) => moment(datetime, 'YYYY-MM-DD HH:mm:ss').isBefore(timeNow)
module.exports.isDatetimePassed = isDatetimePassed
module.exports.isPassed = (date, hour, timeNow) => isDatetimePassed(date + hour, timeNow)

module.exports.logError = (err, context) => {
    console.error(err, context)
}

const normalizePhoneNumber = phone => phone.replace(/[^\d+]/g, '')
module.exports.normalizePhoneNumber = normalizePhoneNumber

const insertAtNegative = (str, char, negativeIndex) => {
    if (str.length < Math.abs(negativeIndex))
        return str;
    return str.slice(0, negativeIndex) + char + str.slice(negativeIndex)
}
module.exports.formatPhoneNumber = phone => {
    if (!phone) return phone
    phone = normalizePhoneNumber(phone)
    if (phone.length > 10) {
        phone = insertAtNegative(phone, ' ', -9)
    }
    if (phone.length > 6) {
        phone = insertAtNegative(phone, ' ', -6)
    }
    if (phone.length > 3) {
        phone = insertAtNegative(phone, ' ', -3)
    }
    return phone
}


module.exports.ArrayToObjectByKey = (arr, key) => arr.reduce((acc, val) => { acc[val[key]] = val; return acc }, {})

module.exports.sortBy = (key, reverse = false) => (l, r) => {
    const lk = l[key], rk = r[key]
    if (lk === rk) return 0
    if (reverse) {
        return lk < rk ? 1 : -1
    }
    return lk < rk ? -1 : 1
}



module.exports.ObjectValues = obj => Object.keys(obj).map(key => obj[key])
module.exports.ObjectMap = (obj, cb) => {
    let newObj = {}
    for (let key in obj) {
        newObj[key] = cb(obj[key], key)
    }
    return newObj
}
module.exports.ObjectFilter = (obj, cb) => {
    let newObj = {}
    for (let key in obj) {
        if (cb(obj[key], key)) {
            newObj[key] = obj[key]
        }
    }
    return newObj
}



module.exports.lang2country = lang => {
    switch (lang.toLowerCase()) {
        case 'en': return 'US';
        default:
            return lang.toUpperCase()
    }
}

module.exports.country2lang = country => {
    switch (country) {
        case 'Bulgaria':
            return 'bg';
        case 'Russian Federation':
        case 'Russia':
        case 'Ukraine':
            return 'ru';
        default:
            return 'en'
    }
}


const recognizeLanguage = input => {
    input = input.toLowerCase()
    switch (input) {
        case 'bg':
        case 'ru':
            // case 'ua':
            return input
        default:
            return 'en'
    }
}
module.exports.recognizeLanguage = recognizeLanguage

const reLang = /^\/(bg|en|ru)(\/|$)/
module.exports.stripLangFromUrlPath = url => url.replace(reLang, '/')
module.exports.extractLangFromUrlPath = url => {
    let res = reLang.exec(url)
    // console.log('PATH res', res)
    if (res) {
        const lang = recognizeLanguage(res[1])
        return lang
    }
    return null
}

module.exports.delay = msec => new Promise(done => setTimeout(() => done(), msec))

module.exports.isServer = () => (typeof window === 'undefined')

// Temporary rollout gate for the embedded-auth relay. Browser detection is
// intentionally isolated here so it can be removed once the relay is enabled
// for every embedded client.
module.exports.isSafariBrowser = (browserNavigator = typeof navigator !== 'undefined' ? navigator : null) => {
    if (!browserNavigator) return false
    const userAgent = String(browserNavigator.userAgent || '')
    const isAppleWebKit = /AppleWebKit/i.test(userAgent)
    const isOtherBrowser = /(Chrome|Chromium|CriOS|FxiOS|Edg|EdgiOS|OPR|OPiOS|SamsungBrowser|DuckDuckGo|GSA|Instagram|FBAN|FBAV)/i.test(userAgent)
    const hasSafariSignature = /Version\/[^\s]+/i.test(userAgent) && /Safari\//i.test(userAgent)
    const isStandaloneAppleWebApp = browserNavigator.standalone === true && /(iPhone|iPad|iPod)/i.test(userAgent)
    return isAppleWebKit && !isOtherBrowser && (hasSafariSignature || isStandaloneAppleWebApp)
}

const sanitizeCurrency = (currency) => {
    if (currency === 'BGN') return currency;

    if (currency === 'лв' || currency === 'лв.' || currency === 'lv' || currency === 'lv.') {
        return 'BGN';
    } else if (currency === 'евро' || currency === 'eur' || currency === '€') {
        return 'EUR';
    }
    return currency.toUpperCase();
}
module.exports.sanitizeCurrency = sanitizeCurrency

const euroRate = 1.95583
const euroSymbol = '€'
module.exports.euroSymbol = euroSymbol
const bgnSymbol = 'лв.'
module.exports.bgnSymbol = bgnSymbol

const getCurrencySymbol = (currency) => {
    return currency && sanitizeCurrency(currency) === 'EUR' ? euroSymbol : currency
}
module.exports.getCurrencySymbol = getCurrencySymbol

const getDualPriceIfNeeded = (value, currency, showDualPrice = true) => {
    if (showDualPrice === false) return [null, null]
    const curr = sanitizeCurrency(currency);
    if (curr === 'BGN' && value) {
        const priceEuro = (value / euroRate).toFixed(2);
        return [priceEuro, euroSymbol]
    }
    if (curr === 'EUR' && value) {
        const priceBgn = (value * euroRate).toFixed(2);
        return [priceBgn, bgnSymbol]
    }
    return [null, null]
}
module.exports.getDualPriceIfNeeded = getDualPriceIfNeeded;

const dualPriceFormatIfNeeded = (value, currency, showDualPrice = true) => {
    const curr = sanitizeCurrency(currency);
    const [dualPrice, dualSymbol] = getDualPriceIfNeeded(value, currency, showDualPrice);
    if (dualPrice) {
        if (curr === 'BGN') {
            return `${value} лв. (${dualPrice} ${dualSymbol})`;
        }
        if (curr === 'EUR') {
            return `${value} € (${dualPrice} ${dualSymbol})`;
        }
    }

    return `${value} ${getCurrencySymbol(currency)}`;
}
module.exports.dualPriceFormatIfNeeded = dualPriceFormatIfNeeded;
